import { combineReducers } from "redux";
import userReducer from "../features/user/redux/reducer";

const rootReducer = combineReducers({
  user: userReducer
});

export default rootReducer;
